import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import React from 'react';
import { Incident, TEMPERATURE_THRESHOLDS } from '../../types';
import { deviceNameCellStyles } from './styles';

interface DeviceNameCellProps {
  params: GridRenderCellParams<Incident>;
  theme: Theme;
}

const DeviceNameCell: React.FC<DeviceNameCellProps> = ({ params, theme }) => {
  const isIncident = params.row.maxCellT > TEMPERATURE_THRESHOLDS.INCIDENT;

  return (
    <Typography sx={deviceNameCellStyles(theme, isIncident)}>
      {params.value}
    </Typography>
  );
};

DeviceNameCell.displayName = 'DeviceNameCell';

export default DeviceNameCell;
